// Utility to parse item codes from a URL
export function parseItemCodes(url, routePattern) {
  // Use routePattern from config if provided
  const pattern = routePattern || /\/([\w,]+)$/;
  const match = url.match(pattern);
  if (!match) return [];
  return match[1].split(',').map(code => code.trim()).filter(Boolean);
}

// Simple in-memory cache with 1 hour expiry
const cache = {};
const CACHE_DURATION = 60 * 60 * 1000; // 1 hour

export async function fetchItemImages(itemCode, baseUrl, token, documentBaseId) {
  const cacheKey = `${itemCode}`;
  const now = Date.now();
  if (cache[cacheKey] && now - cache[cacheKey].timestamp < CACHE_DURATION) {
    return cache[cacheKey].data;
  }
  // Use documentBaseId from config
  const url = `${baseUrl}/DocumentInfo/GetPermalinksFromDocumentInfoValueByBaseId?documentBaseId=${documentBaseId}&language=no&value=${itemCode}`;
  console.log('fetchItemImages: Fetching', url);
  try {
    const res = await fetch(url);
    if (!res.ok) {
      const text = await res.text();
      console.error('fetchItemImages: API error', res.status, text);
      throw new Error(`Failed to fetch images: ${res.status} ${text}`);
    }
    const data = await res.json();
    console.log('fetchItemImages: API response', data);
    // data is an array, each item has DocumentId, DocumentInfos, Sortorder
    const images = [];
    for (const item of data) {
      if (Array.isArray(item.DocumentInfos)) {
        for (const doc of item.DocumentInfos) {
          if (doc.Name === 'Galleribilde') {
            images.push({
              ...doc,
              DocumentId: item.DocumentId,
              Sortorder: item.Sortorder
            });
          }
        }
      }
    }
    images.sort((a, b) => a.Sortorder - b.Sortorder);
    cache[cacheKey] = { data: images, timestamp: now };
    return images;
  } catch (err) {
    console.error('fetchItemImages: Network or parsing error', err);
    throw err;
  }
}

function normalizeFormat(format) {
  if (!format) return 'jpg';
  const f = format.toLowerCase();
  if (f === 'jpeg') return 'jpg';
  if (f === 'jpg' || f === 'png' || f === 'gif' || f === 'bmp' || f === 'webp') return f;
  return 'jpg';
}

export async function downloadImage(documentId, token, asAttachment = true, baseUrl, format = 'jpg') {
  const url = `${baseUrl}/Download`;
  const xmlBody = `<?xml version="1.0"?>\n<DownloadRequest>\n  <DocumentId>${documentId}</DocumentId>\n  <Quality>FullSize</Quality>\n  <DownloadAsAttachment>${asAttachment}</DownloadAsAttachment>\n</DownloadRequest>`;
  const res = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/xml',
      'Accept': 'application/json',
      'token': token,
    },
    body: xmlBody,
  });
  // Try to parse as JSON (Download API returns { Url, Format })
  let apiJson = null;
  try {
    apiJson = await res.clone().json();
  } catch (e) {}
  if (apiJson && apiJson.Url && apiJson.Format) {
    // Download the actual image from the Url
    const imgRes = await fetch(apiJson.Url);
    const blob = await imgRes.blob();
    const ext = normalizeFormat(apiJson.Format);
    return { blob, format: ext };
  }
  // Fallback: handle as before
  if (!res.ok) throw new Error('Download failed');
  const blob = await res.blob();
  const ext = normalizeFormat(format);
  return { blob, format: ext };
}
